// Assets feature — query-key gyár + a lista-szűrő típusa. A tényleges hívásokat a route a tipizált
// ts-rest kliensen (`api.assets.*`) intézi; a kulcsok itt élnek (cache-egységesítés). A `@atlas/contracts`
// a szerződés forrás-igazsága — itt csak kulcs-logika van (a tickets feature-mintára).

/** A lista-lekérdezés szűrői (a query-kulcs része — szűrő-/rendezés-/tab-váltás új cache-bejegyzést nyit).
 *  A `scope` a tab (inventory = meglévő | request = igényelt), a `sort` a rendezés-KULCS (assetNumber | name |
 *  type | status | holderName | requesterName | teamName | netPrice | purchaseDate), az `order` az irány;
 *  a `q`/`status`/`type` a toolbar-szűrők. */
export interface AssetListFilters {
  scope: 'inventory' | 'request';
  q: string;
  status: string;
  type: string;
  /** Csapat-szűrő (UUID) vagy a „mind" érték. */
  team?: string;
  /** Munkatárs-szűrő (identity UUID) vagy a „mind" érték — a birtokos VAGY a „kinek". */
  holder?: string;
  sort: string;
  order: 'asc' | 'desc';
  /** Nézet-particionálás (leltár / igénylések) — kliens-oldali szűrő, de a cache-kulcs része. */
  view?: 'inventory' | 'requests';
}

/** Query-kulcs gyár — a lista-cache egységes címzése. */
export const assetKeys = {
  all: ['assets'] as const,
  lists: () => ['assets', 'list'] as const,
  list: (filters: AssetListFilters) => ['assets', 'list', filters] as const,
  /** Egy eszköz / igény (az igény-sáv és a mélylink olvassa — a lista betöltött lapjától független). */
  detail: (id: string) => ['assets', 'detail', id] as const,
};
